// extracted by mini-css-extract-plugin
export var modal = "_co-0";